import React, { useState } from 'react'
import EligibilityDetails from '../Eligibility/components/responseEligbility/EligibilityDetails'
import AramcoForm from './AramcoForm'

function AramcoHelpDesk () {
  const [chiReqRecord, setChiReqRecord] = useState(null)
  const [systemType, setSystemType] = useState(null)
  const [eligibilityId, setEligibilityId] = useState(null)
  const [patientName, setPatientName] = useState('')

  return (
    <div>
      <AramcoForm
        chiReqRecord={chiReqRecord}
        setChiReqRecord={setChiReqRecord}
        systemType={systemType}
        setSystemType={setSystemType}
        eligibilityId={eligibilityId}
        setEligibilityId={setEligibilityId}
        patientName={patientName}
        setPatientName={setPatientName}
      />
      {eligibilityId && (
        <EligibilityDetails helpDeskItem={{ transaction_id: eligibilityId }} />
      )}
    </div>
  )
}

export default AramcoHelpDesk
